import React, { useState, useEffect } from 'react'
import DropDown from './DropDown';
import { isMobile } from 'react-device-detect';

const ByFilters = (props) => {
    const [filtergrounp, setFiltergroup] = useState({
        dropdownlabel: [],
        dropdowndata: []
    })

    const [fetchData, setFetchData] = useState([])
    const [removeitem, setRemoveitem] = useState()

    useEffect(() => {
        setFiltergroup({
            dropdownlabel: props.filtergrouplabel,
            dropdowndata: props.apidata.data.filters
        })
    }, [props.apidata, props.filtergrounpdata])

    useEffect(() => {
        //console.log(props.removeitem)
        let res = props.removeitem === null ? [] : fetchData.filter(item => item.value !== props.removeitem.filterItemID)
        setFetchData(res)
        setRemoveitem(fetchData.filter(item => item.value === props.removeitem.filterItemID))
    }, [props.removeitem])

    const getResult = (result) => {
        //console.log('arraydata: '+JSON.stringify(result.data))
        let arraydata = fetchData
        if (result.data.length !== 0) {
            result.data.map(item => {
                //console.log('fetchData: '+JSON.stringify(fetchData))  
                arraydata = fetchData.filter(items => items.groupid === item.groupid)
                arraydata = arraydata.filter(items => items.value != item.value)
                //console.log(fetchData.includes(item)+' : '+JSON.stringify(arraydata))
                //console.log(item.groupid)
                //fetchData.filter(items => items !== item.groupid)

                setFetchData(
                    //fetchData => !fetchData.includes(item) ? fetchData.concat(item) : fetchData.splice(fetchData.indexOf(fetchData.filter(res => res.value === item.value)), 1)
                    fetchData => !fetchData.includes(item) ? fetchData.concat(item) : fetchData.filter(item => item != arraydata[0])
                )
            }
            )
        } else {
            setFetchData(
                fetchData => !fetchData.includes(result.data) ? fetchData.concat(result.data) : fetchData.splice(fetchData.indexOf(result.data), 1)
            )
        }
    }

    const clearids = (id) => {
        setFetchData(
            fetchData => fetchData.filter(res => res.groupid !== id)
        )
    }

    useEffect(() => {
        //console.log(fetchData)
        if (fetchData.length > 0 && fetchData !== null) {
            let group = fetchData.reduce((r, a) => {
                r[a.groupid] = [...r[a.groupid] || [], a];
                return r;
            }, {});

            var result = Object.keys(group).map(function (key) {
                return {
                    "filterGroupId": "{" + key + "}",
                    "filterItems": group[key].map(d => ({ "filterItemId": d.value, "filterItemLabel": d.itemname }))
                }
            });
            props.filterData(result)
            props.filterlist(fetchData.length > 0 && fetchData !== null && fetchData)
            //console.log('groupdata',JSON.stringify(fetchData))
            //localStorage.setItem('groupdata',JSON.stringify(result)    )
        }
        else {
            props.filterData([])
        }
    }, [fetchData])

    return (
        <>
            {!isMobile && <div class="filter-group">
                <DropDown
                    dlabel={filtergrounp.dropdownlabel}
                    ddata={filtergrounp.dropdowndata}
                    result={getResult}
                    clearids={clearids}
                    clearallitems={removeitem}
                    {...props}
                />
            </div>}
            {isMobile && <DropDown
                dlabel={filtergrounp.dropdownlabel}
                ddata={filtergrounp.dropdowndata}
                result={getResult}
                clearids={clearids}
                clearallitems={removeitem}
                {...props}
            />}
        </>



    );
}

export default ByFilters;
